module.exports = __webpack_public_path__ + "img/lan_tour_route_01.53c98fff.jpg";